import React, { useState } from "react";
import { Tabs, Tab, Box, Card } from "@mui/material";
import DatingFriendTab from "./DatingFriendTab";
import FriendsTab from "./friendsTab";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`sub-tabpanel-${index}`}
      aria-labelledby={`sub-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
};

const MainFriendShipTab: React.FC = () => {
  const [subTab, setSubTab] = useState<number>(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSubTab(newValue);
  };

  return (
    <Card sx={{}} variant="outlined">
      <Box>
        <Tabs
          value={subTab}
          onChange={handleChange}
          aria-label="Main History Tabs"
          sx={{
            minHeight: "45px",

            "& .MuiTab-root": {
              color: "black",
              fontWeight: "bold",
              textTransform: "none",
              padding: "10px 25px",
              minHeight: "45px",
            },
            "& .Mui-selected": {
              backgroundColor: "#000",
              color: "#fff !important",
            },

            "& .MuiTabs-flexContainer": {
              gap: "10px",
              padding: "8px 10px 0 0px",
            },

            "& .MuiTabs-indicator": {
              display: "none",
            },
            boxShadow: "inset 0 -2px 6px rgba(0,0,0,0.08)",
          }}
        >
          <Tab label="Dating Friends" id="sub-tab-0" />
          <Tab label="Friends" id="sub-tab-1" />
        </Tabs>
        <TabPanel value={subTab} index={0}>
          <DatingFriendTab />
        </TabPanel>

        <TabPanel value={subTab} index={1}>
          <FriendsTab />
        </TabPanel>
      </Box>
    </Card>
  );
};

export default MainFriendShipTab;
